// extracted by mini-css-extract-plugin
export var readonly = "_hk-1";
export var star = "_hk-0";